import { render, staticRenderFns } from "./AppPlaceholder.vue?vue&type=template&id=4b1f22e8&"
import script from "./AppPlaceholder.vue?vue&type=script&lang=js&"
export * from "./AppPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports